// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/touch-and-go-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/touch-and-go-technique/touch-and-go-technique.js';

mount([g0]);
